import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CalendarSvg = () => (
  <svg
    width='1em'
    height='0.925em'
    viewBox='0 0 25 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.4293 4.09912H4.42927C3.1669 4.09912 2.14355 5.12247 2.14355 6.38484V22.3848C2.14355 23.6472 3.1669 24.6705 4.42927 24.6705H20.4293C21.6916 24.6705 22.715 23.6472 22.715 22.3848V6.38484C22.715 5.12247 21.6916 4.09912 20.4293 4.09912Z'
      stroke='url(#paint0_linear_537_14335)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 1.81323V6.38466'
      stroke='url(#paint1_linear_537_14335)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.85742 1.81323V6.38466'
      stroke='url(#paint2_linear_537_14335)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.14355 10.9563H22.715'
      stroke='url(#paint3_linear_537_14335)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_537_14335'
        x1='2.14355'
        y1='4.09912'
        x2='23.4687'
        y2='4.91261'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_537_14335'
        x1='17'
        y1='1.81323'
        x2='18.0381'
        y2='1.82189'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_537_14335'
        x1='7.85742'
        y1='1.81323'
        x2='8.8955'
        y2='1.82189'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_537_14335'
        x1='2.14355'
        y1='10.9563'
        x2='15.3605'
        y2='21.3282'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const CalendarColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CalendarSvg} {...props} />
);
